
























import { Component, Watch, Vue } from 'vue-property-decorator';
import Logo from '@/assets/logo.svg';
import Hamburger from '@/assets/hamburger.svg';
import Github from '@/assets/github.svg';

@Component({
  components: {
    Logo,
    Hamburger,
    Github,
  },
})
export default class Navbar extends Vue {
  public menuIsOpen: boolean = false;

  @Watch('$route', { immediate: true, deep: true })
  public onUrlChange() {
    this.menuIsOpen = false;
  }

  public toggleMenu() {
    this.menuIsOpen = !this.menuIsOpen;
  }

  public toTop() {
    this.hideMenu();
    window.scrollTo(0, 0);
  }

  public hideMenu() {
    this.menuIsOpen = false;
  }
}
